import { DIFFICULTIES } from '../constants/config'

// Build static lookup so Tailwind can see full class names at build time
const CONFIG = {
  Beginner:     { bg: 'bg-emerald-500/10', text: 'text-emerald-400', border: 'border-emerald-500/20', dot: 'bg-emerald-400' },
  Intermediate: { bg: 'bg-sky-500/10',     text: 'text-sky-400',     border: 'border-sky-500/20',     dot: 'bg-sky-400'     },
  Advanced:     { bg: 'bg-amber-500/10',   text: 'text-amber-400',   border: 'border-amber-500/20',   dot: 'bg-amber-400'   },
  Expert:       { bg: 'bg-rose-500/10',    text: 'text-rose-400',    border: 'border-rose-500/20',    dot: 'bg-rose-400'    },
}

// Derive label from shared DIFFICULTIES constant
const LABEL = Object.fromEntries(DIFFICULTIES.map(d => [d.key, d.label]))

export default function DifficultyBadge({ level }) {
  if (!level) return null
  const c = CONFIG[level] ?? CONFIG.Intermediate
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${c.bg} ${c.text} ${c.border}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {LABEL[level] ?? level}
    </span>
  )
}
